<template>
  <div class="viewContent">
    <l-dialog
      :show="isInfo"
      :isbtn="false"
      :ischa="true"
      @cancel="isInfo=false"
      class="msgDialog"
      :title="showEchart ? recordInfo.title : info.title"
    >
      <div class="oneLeft" v-show="!showEchart">
        <h1>{{info.title}}</h1>
        <p class="tag">包含{{ childList.length }}量表</p>
        <div class="tab">
          <table>
            <tr>
              <th style="width:3.2rem">量表名称</th>
              <th style="width:2.2rem">量表分类</th>
              <th style="width:1rem">操作</th>
            </tr>
            <tr v-for="(item,index) in childList" :key="index">
              <td style="text-align:left;padding-left:.2rem">{{item.gaugeTitle}}</td>
              <td>{{resultInfo.title}}</td>
              <td>
                <l-button value="查看" color="#3170FF" @click.native="handLookInfo(item)"></l-button>
                <div class="bad" v-show="item.isRead==0"></div>
              </td>
            </tr>
          </table>
        </div>
        <p class="markTitle">—— 对本次普查的整体点评 ——</p>
        <div class="eval">
          <el-input type="textarea" v-model="mark"></el-input>
        </div>
      </div>
      <div class="left" v-show="showEchart">
        <p class="tit">测试结果</p>
        <div ref="bar" id="bar" style="height:3rem;width:6.2rem"></div>
        <div v-for="(item,index) in recordResult" :key="index" style="padding-right:.5rem">
          <p class="tag">【{{item.gradeName}}】：{{item.scores}}</p>
          <p class="tag">{{item.degree}}</p>
          <p class="msg" v-html="item.result"></p>
        </div>
      </div>
      <div class="right">
        <p class="tit">—— 用户资料 ——</p>
        <p>
          姓名：
          <span>{{info.nickname}}</span>
        </p>
        <p>
          性别：
          <span>{{info.sex}}</span>
        </p>
        <p>
          年龄：
          <span>{{info.age}}</span>
        </p>
        <p>
          部门：
          <span>{{info.deptname}}</span>
        </p>
        <p>
          编号：
          <span>{{info.student_id}}</span>
        </p>
        <p>
          生成：
          <span>{{formatDate(info.addTime)}}</span>
        </p>
        <div class="btn" v-show="showEchart">
          <l-button value="关闭" @click.native="showEchart=false,getChildList()"></l-button>
        </div>
        <div class="btn2" v-show="!showEchart">
          <l-button value="删除" color="#FF500C" @click.native="operate()"></l-button>
          <l-button value="关闭" @click.native="isInfo=false"></l-button>
        </div>
      </div>
    </l-dialog>

    <div class="search">
      <p>您可以在这里管理所有的量表：</p>
      <div>
        <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="search">
          <template slot="append">
            <span @click="getResult({page:1})">搜索</span>
          </template>
        </el-input>
      </div>
    </div>
    <div class="table">
      <div class="type">共有普查测评结果：{{queryObj.total}}份</div>
      <table style="padding:0 .35rem" cellspacing="0">
        <tr>
          <th style="width:4.5rem" @click="scaleTh = !scaleTh">
            普查任务名称
            <i class="el-icon-caret-bottom"></i>
            <eject-select-list class="selectScale" :show.sync="scaleTh">
              <p :class="{'on':queryObj.sort == 'asc'}" @click="getResult({time:'',sort:'asc',})">按拼音（正序）</p>
              <p :class="{'on':queryObj.sort == 'desc'}" @click="getResult({time:'',sort:'desc',})">按拼音（倒序）</p>
            </eject-select-list>
          </th>
          <th style="width:1.3rem">包含量表</th>
          <th style="width:1.8rem">发布人</th>
          <th style="width:2rem" @click="timeTh = !timeTh">
            结果生成日期
            <i class="el-icon-caret-bottom"></i>
            <eject-select-list class="selectTime" :show.sync="timeTh">
              <l-date-picker v-model="queryObj.date" @change="getResult({page:1})"></l-date-picker>
              <!--<p @click="isDate=!isDate">选择日期范围</p>
              <div v-show="isDate" style="margin-top:.05rem">
                <div>
                  <el-input v-model="startDate" style="width:.9rem"></el-input>
                  <span style="margin:0 5px">-</span>
                  <el-input v-model="endDate" style="width:.9rem"></el-input>
                  <i
                    class="el-icon-search"
                    style="font-size:.18rem;margin-left:.05rem"
                    @click="getResult(),timeTh=false,startDate='',endDate=''"
                  ></i>
                </div>
                <Calendar
                  @choseDay="clickDay"
                  @changeMonth="changeDate"
                  :markDate="markDate"
                  ref="cale"
                />
              </div>-->
              <p :class="{'on':queryObj.time == 'asc'}" @click="getResult({time:'asc',sort:''})">按最远建立排序</p>
              <p :class="{'on':queryObj.time == 'desc'}" @click="getResult({time:'desc',sort:''})">按最近建立排序</p>
            </eject-select-list>
          </th>
          <th style="width:1.65rem" @click="statusTh = !statusTh">
            结果是否可查看
            <i class="el-icon-caret-bottom"></i>
            <eject-select-list class="selectStatus" :show.sync="statusTh">
              <p :class="{'on':queryObj.status == ''}" @click="getResult({status:'',page: 1})">全部</p>
              <p :class="{'on':queryObj.status == 1}" @click="getResult({status:1,page: 1})">可查看</p>
              <p :class="{'on':queryObj.status == 2}" @click="getResult({status:2,page: 1})">不可查看</p>
            </eject-select-list>
          </th>
          <th style="width:2.35rem">操作</th>
        </tr>
        <tr v-for="(item) in resultList" :key="item.publishId" @click="nowClickRow = item" :style="{ 'background': nowClickRow == item ? '#e0f0ff' : '' }">
          <td>
            <div class="td4">
              <img src="@/assets/img/home/pc.png" alt />
              {{item.title}}
            </div>
          </td>
          <td>{{item.gaugeTotal}}</td>
          <td>{{item.publishName}}</td>
          <td>{{formatDate(item.addTime)}}</td>
          <td>{{item.isView==1 ? '可查看' : item.isView==2 ? '不可查看' : '待批阅'}}</td>
          <td>
            <l-button
              value="查看"
              color="#3170FF"
              @click.native="handLook(item)"
              :disabled="item.isView !=1 ? true : false"
            ></l-button>
            <l-button
              value="删除"
              color="#F0F0F0"
              style="color:#333333;margin-left:.15rem"
              @click.native="operate(item)"
            ></l-button>
          </td>
        </tr>
      </table>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="queryObj.total"
      :currentPage="queryObj.page"
      :page-size="queryObj.pageSize"
      @current-change="changePage"
    ></el-pagination>
  </div>
</template>

<script>
import lButton from "@/components/lButton.vue";
import lDialog from "@/components/lDialog.vue";
import { formatDate1 } from "../../../../assets/js/formatDate";
import { formatDate2 } from "@/utils/common/formatDate.js";
import Calendar from "vue-calendar-component";
let bar = "";
export default {
  data() {
    return {
      nowClickRow: null,
      uid: JSON.parse(localStorage.getItem("userinfo")).uid,
      resultList: [],
      childList: [],
      scaleTh: false,
      timeTh: false,
      statusTh: false,
      search: "",
      //详情
      isInfo: false,
      showResult: true,
      showEchart: false,
      info: {},
      resultInfo: {},
      mark: "",
      //图表
      recordResult: {},
      recordInfo: {},
      record: [],
      //模板
      isFlot: false,
      isMark: false,
      markList: [],
      modelType: 1,
      modelTitles: {},
      modelTitle: "",
      modelMsg: "",
      //分页
      page: 1,
      total: 0,
      //echarts
      base64: "",
      //日期
      isDate: false,
      startDate: "",
      endDate: "",
      markDate: [],

      queryObj: {
        sex: '',
        cid: '',
        sort: '',
        date: [],
        time: '',
        status: '',
        page: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  methods: {
    handEcharts() {
      //销毁echarts实例
      if (bar) {
        bar.dispose();
      }
      bar = this.echarts.init(this.$refs.bar);
      let colors = ['#0AA7F4','#ED6942','#F29EC2','#36D5E5','#12B5B0','#F9B552','#e91e63','#f44336','#EEAD0E','#E066FF','#B3EE3A'];
      let option = {
        grid: {
          top: "30",
          left: "40",
          right: "50",
          bottom: "60",
        },
        xAxis: {
          type: "category",
          //data: Array.from({ length: this.record.length }, (x, i) => x + i),
          axisLine: {
            symbol: ["none", "arrow"], //---是否显示轴线箭头
            symbolSize: [8, 8], //---箭头大小
            symbolOffset: [0, 7], //---箭头位置
            lineStyle: {
              color: "rgba(51,51,51,0.5)",
            },
          },
          axisTick: {
            //---坐标轴 刻度
            show: true, //---是否显示
            inside: true, //---是否朝内
            lengt: 2, //---长度
            lineStyle: {
              //color:'red',			//---默认取轴线的颜色
              width: 1,
              type: "solid",
            },
          },
          axisLabel: {
            interval: 0,
            rotate: 30,
            color: "#404040", //更改坐标轴文字颜色
            fontWeight: 100,
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
            symbol: ["none", "arrow"], //---是否显示轴线箭头
            symbolSize: [8, 8], //---箭头大小
            symbolOffset: [0, 10], //---箭头位置
            lineStyle: {
              color: "rgba(51,51,51,0.5)",
            },
          },
          axisTick: {
            //---坐标轴 刻度
            show: false, //---是否显示
          },
          splitLine: {
            //---grid 区域中的分隔线
            show: true, //---是否显示，'category'类目轴不显示，此时我的X轴为类目轴，splitLine属性是无意义的
            lineStyle: {
              color: "#404040",
              opacity: "0.2",
              width: 1,
              type: "dashed",
            },
          },
          axisLabel: {
            color: "#404040", //更改坐标轴文字颜色
            fontWeight: 100,
          },
        },
        series: [
          {
            type: "bar",
            itemStyle: {
              //---图形形状
              borderRadius: [5, 5, 0, 0],
              color: function (params) {
                return colors[params.dataIndex % colors.length];
              },
            },
            barWidth: 20, //---柱形宽度
            // barCategoryGap: "20%", //---柱形间距
            data: this.record,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      bar.setOption(option);
      window.addEventListener("resize", function () {
        bar.resize();
      });
    },
    //获取结果列表
    async getResult(qObj = this.queryObj) {
      qObj = Object.assign(this.queryObj, qObj)
      let { data } = await this.$post("api/test/getTableResultList", {
        testType: 3,
        curPage: qObj.page,
        pageSize: qObj.pageSize,
        name: this.search,
        starttime: formatDate2(qObj.date[0], 'yyyy-MM-dd'),
        endtime: formatDate2(qObj.date[1], 'yyyy-MM-dd'),
        sex: qObj.sex,
        catId: qObj.cid,
        title_desc: qObj.sort,
        time_desc: qObj.time,
        isView: qObj.status,
      });
      console.log(data);
      this.checkAll = false;
      this.checkLists = [];
      this.resultList = data.data.list;
      this.queryObj.total = data.data.total;
    },
    //重新获取子任务列表
    async getChildList() {
      let { data } = await this.$post("api/test/getSurveyResultList", {
        publishId: this.info.publishId,
      });
      this.childList = data.data.list;
    },
    //查看
    async handLook(item) {
      this.isInfo = true;
      this.showEchart = false;
      this.info = item;
      //获取子任务列表
      let { data } = await this.$post("api/test/getSurveyResultList", {
        publishId: item.publishId,
      });
      this.childList = data.data.list;
      this.resultInfo = data.data.info;
      this.mark = this.resultInfo.comment;
    },
    //查看子列表详情
    async handLookInfo(item) {
      console.log(item);
      this.showEchart = true;
      let { data } = await this.$post("api/test/getTableResultById", {
        id: item.recordId,
      });

      let recordResult = data.data.list.recordResult
      let resultCategory = []
      for (let key in recordResult) {
        resultCategory.push(recordResult[key])
      }
      data.data.list.recordResult = recordResult

      this.recordResult = data.data.list.recordResult;
      this.recordInfo = data.data.list;
      this.record = this.recordResult.map((item) => {
        return [item.gradeName, item.scores];
      });
      this.$post("api/test/getReadTable", {
        testType: 3,
        id: item.recordId,
      });
      this.handEcharts();
    },
    //删除
    async operate(info = this.info) {
      this.$popup({
        title: '提示',
        content: '是否要删除该记录？',
        saveFoo: () => {
          this.$post("api/test/tableResultOperate", {
            testType: 3,
            type: 4,
            id: info.publishId,
            publishId: info.publishId,
          }).then(() => {
            this.isInfo = false;
            this.info = {};
            this.getResult();
          })
        },
      })
    },
    //分页
    changePage(page) {
      this.queryObj.page = page;
      this.getResult();
    },
    //日期格式转换
    formatDate(time) {
      return formatDate1(time);
    },
    //选择日期
    clickDay(val) {
      if (this.markDate.length < 2) {
        this.markDate.push(val);
      } else {
        if (new Date(val) > new Date(this.markDate[1])) {
          this.$set(this.markDate, 1, val);
        } else if (new Date(val) < new Date(this.markDate[0])) {
          this.$set(this.markDate, 0, val);
        } else {
          this.$set(this.markDate, 0, val);
          this.$set(this.markDate, 1, val);
        }
      }
      this.startDate = this.markDate[0];
      this.endDate = this.markDate[1];
    },
    changeDate(val) {
      console.log(val);
    },
  },
  mounted() {
    this.getResult();
  },
  components: {
    "l-button": lButton,
    "l-dialog": lDialog,
    Calendar,
  },
};
</script>

<style lang='less' scoped>
.viewContent {
  //弹出框
  /deep/.markDialog {
    height: 460px;
    width: 750px;
    z-index: 100;
    .content {
      padding: 41px 0 0 58px;
      .ipt {
        display: flex;
        align-items: flex-start;
        font-size: 14px;
        .el-radio-group {
          margin-top: 2px;
        }
        .el-input__inner,
        .el-textarea__inner {
          border: 0;
          background: #f0f0f0;
        }
      }
    }
  }
  //详情
  /deep/.msgDialog .dialog {
    width: 1000px;
    height: 750px;
    .content {
      display: flex;
    }
    .oneLeft {
      width: 719px;
      overflow-y: auto;
      border-right: 1px solid #f0f0f0;
      padding-left: 30px;
      box-sizing: border-box;
      h1 {
        padding-top: 27px;
        font-size: 20px;
        font-weight: 400;
        text-align: center;
        color: #333333;
      }
      .tag {
        font-size: 14px;
        text-align: center;
        color: #777;
        margin: 10px 0 26px 0;
      }
      .tab {
        max-height: 295px;
        overflow-y: auto;
      }
      table {
        font-size: 14px;
        border-collapse: collapse;
        text-align: center;
        th {
          background: #f7f7f7;
          height: 40px;
          color: #777777;
          font-weight: 400;
        }
        tr {
          position: relative;
        }
        td {
          height: 50px;
          color: #333333;
          border-bottom: 1px solid #f0f0f0;
          button {
            height: 32px;
            width: 60px;
          }
        }
        .bad {
          background: red;
          height: 10px;
          width: 10px;
          border-radius: 50%;
          position: absolute;
          top: 6px;
          right: 16px;
        }
      }
      .markTitle {
        text-align: center;
        color: #333333;
        margin: 28px 0 20px 0;
      }
      .eval {
        height: 160px !important;
        width: 640px;
        overflow: hidden;
        border: 1px solid #f0f0f0;
        border-radius: 10px;
        .el-textarea__inner {
          height: 160px;
          border: 0;
          background: #f0f0f0;
        }
        .el-checkbox__label {
          display: inline-block;
          color: #333;
        }
        .foot {
          color: #333;
          height: 39px;
          display: flex;
          align-items: center;
          padding-left: 20px;
        }
        .mark {
          position: relative;
          display: flex;
          margin-left: 250px;
          img {
            width: 16px;
          }
          .flot {
            position: absolute;
            top: -160px;
            left: -10px;
            width: 120px;
            height: 150px;
            overflow: auto;
            background: #ffffff;
            border-radius: 6px;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
            li {
              height: 50px;
              line-height: 50px;
              text-align: center;
              border-bottom: 1px solid #f0f0f0;
              box-sizing: border-box;
              &:hover {
                background: #f0f0f0;
              }
            }
          }
        }
      }
    }
    .left {
      width: 719px;
      overflow-y: auto;
      border-right: 1px solid #f0f0f0;
      padding-left: 59px;
      box-sizing: border-box;
      .tit {
        color: #404040;
        padding-top: 39px;
      }
      .tag {
        color: #404040;
        margin-bottom: 25px;
      }
      .tag:nth-child(1) {
        text-indent: -8px;
      }
      .msg {
        font-size: 14px;
        color: #555555;
        line-height: 30px;
      }
    }
    .right {
      font-size: 14px;
      width: 280px;
      box-sizing: border-box;
      .tit {
        margin: 39px 0 29px 0;
        text-align: center;
        color: #5f5f5f;
      }
      p {
        margin-left: 30px;
        margin-bottom: 25px;
      }
      span {
        color: #555;
      }
      .btn {
        position: absolute;
        height: 40px;
        width: 240px;
        text-align: center;
        line-height: 40px;
        bottom: 50px;
        right: 20px;
        button {
          width: 70px;
          margin: 0 5px;
        }
      }
      .btn2 {
        position: absolute;
        height: 40px;
        width: 240px;
        text-align: center;
        line-height: 40px;
        bottom: 50px;
        right: 20px;
        button {
          width: 80px;
          margin: 0 5px;
        }
      }
    }
  }
  /deep/.delLog {
    width: 350px;
    height: 240px;
    p {
      padding: 49px 0 24px 0;
      color: #333333;
      text-align: center;
    }
  }

  .table {
    margin-top: 20px;
    height: 770px;
    width: 1430px;
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    .type {
      height: 60px;
      line-height: 60px;
      color: #222222;
      background: #f0f0f0;
      text-align: center;
    }
    table {
      font-size: 14px;
      tr {
        height: 55px;
        text-align: center;
      }
      th {
        color: #555;
        font-weight: 400;
        position: relative;
        .el-checkbox {
          margin-right: 5px;
        }
      }
      td {
        height: 55px;
        .el-checkbox {
          margin: 0 20px 0 5px;
        }
      }
      .td1 {
        display: flex;
        align-items: center;
        position: relative;
        .bad {
          position: absolute;
          left: 72px;
          top: 0px;
          height: 10px;
          width: 10px;
          background-color: red;
          border-radius: 50%;
        }
        img {
          height: 36px;
          width: 36px;
          margin-right: 18px;
          border-radius: 50%;
          border: 2px solid #3170ff;
        }
      }
      .td4 {
        display: flex;
        align-items: center;
        height: 55px;
        box-sizing: border-box;
        img {
          margin: 0 20px 0 30px;
          width: 40px;
          height: 20px;
        }
      }
      
      th,
      td {
        border-bottom: 1px solid #f0f0f0;
      }
      button {
        height: 40px;
        width: 80px;
        border-radius: 6px;
        border: 0;
        font-size: 14px;
      }
      .edit {
        margin-right: 15px;
        background: #3170ff;
        color: #fff;
      }
      .del {
        background: #f0f0f0;
        color: #333333;
      }
    }
  }
  .el-pagination {
    bottom: 70px;
  }
}
</style>